import { render, staticRenderFns } from "./ualityStandards.vue?vue&type=template&id=501eb4fe&scoped=true"
import script from "./ualityStandards.vue?vue&type=script&lang=js"
export * from "./ualityStandards.vue?vue&type=script&lang=js"
import style0 from "./ualityStandards.vue?vue&type=style&index=0&id=501eb4fe&prod&lang=scss&scoped=true"
import style1 from "./ualityStandards.vue?vue&type=style&index=1&id=501eb4fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501eb4fe",
  null
  
)

export default component.exports